import React, { useEffect, useState, useCallback } from "react";
import DataTable from "react-data-table-component";
import Select from "react-select";
import DatePicker from "react-datepicker";
import "moment-timezone";
import Moment from "react-moment";
import { TailSpin } from "react-loader-spinner";
import { NavLink } from "react-router-dom";
import "./preojekte.scss";
import { ApiGet, ApiGetNoAuth, ApiPost, ApiPut } from "../../../helpers/API/ApiData";
import useDebounce from "../../../hooks/useDebounceHook";
import { toast } from "react-toastify";
import { Modal } from "react-bootstrap";

import Moreicon from "../../../assets/icon/more.png";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import moment from "moment/moment";
import CustomCalendar from "../Calendar/calender";
import AddLeadDetails from "./addNewLead/AddLeadDetails";
import { getUserInfo } from "../../../utils/user.util";

export default function Projekte() {
  const [tickets, setTickets] = useState([]);
  const [modal, setModal] = useState(false);
  const [leadData, setLeadData] = useState();
  const [id, setId] = useState();
  const [search, setSearch] = useState();

  const [isShowLeadModel, setIsShowLeadModel] = useState(false);
  const [inputValue, setInputValue] = useState({});
  const [error, setError] = useState({});
  const [addUpdateLoader, setAddUpdateLoader] = useState(false);
  const [isEditLead, setIsEditLead] = useState(false);
  const usersData = getUserInfo();

  const [leadId, setLeadId] = useState();
  const [statusModal, setStatusModal] = useState(false);
  const [updatedStaus, setUpdatedStatus] = useState();
  const [reason, setReason] = useState();
  const [laoding, setLoading] = useState(false);
  const debouncValue = useDebounce(search, 400);

  const [destinatedStatus, setDestinatedStatus] = useState();

  const ALL_STATUS = [
    { id: "11", status: "offen" },
    { id: "20", status: "NICHT ERREICHT" },
    { id: "12", status: "ZEITLICHE VERZÖGERUNG" },
    {id:"13",status:"Termin"},
    {id:"14",status:"Vertragsverhandlung"},
    { id: "19", status: "STORNO" },
    { id: "16", status: "GEWONNEN" },
  ];

  useEffect(() => {
    const currentUrl = window.location.href;
    const url = new URL(currentUrl);
    const id = url.searchParams.get("id");
    setId(id);
  }, [window.location.href]);

  const getStatusWiseData = async () => {
    try {
      if (id) {
        const response = await ApiGet(`vattenfall/getIdUserConformLead?id=${id}`);
        setTickets(response?.data?.payload?.findConform);
      } else {
        const response = await ApiGet(`vattenfall/getConformLead${debouncValue ? `?search=${debouncValue}` : ""}`);
        setTickets(response?.data?.payload?.findConform);
      }
    } catch (error) {
      toast.error("error", error.message);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setInputValue({ ...inputValue, [name]: value });
    setError({ ...error, [name]: "" });
  };

  const handleAddNewsClose = () => {
    setIsShowLeadModel(false);
    setInputValue({});
    setError({});
  };

  const ValidateForm = () => {
    let error = {};
    let isValid = true;
    const EMAIL_REGEX = /^(([^<>()[\]\\.,;:\s@“]+(\.[^<>()[\]\\.,;:\s@“]+)*)|(“.+“))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    // if (!inputValue?.anrede || inputValue?.anrede?.trim() === "") {
    //   error.anrede = "Bitte überprüfe deine Eingabe";
    //   isValid = false;
    // }
    // if (!inputValue?.vorname || inputValue?.vorname?.trim() === "") {
    //   error.vorname = "Bitte überprüfe deine Eingabe";
    //   isValid = false;
    // }
    // if (!inputValue?.nachname || inputValue?.nachname?.trim() === "") {
    //   error.nachname = "Bitte überprüfe deine Eingabe";
    //   isValid = false;
    // }
    if (!inputValue?.firma || inputValue?.firma?.trim() === "") {
      error.firma = "Bitte überprüfe deine Eingabe";
      isValid = false;
    }
    if (!inputValue?.adresse || inputValue?.adresse?.trim() === "") {
      error.adresse = "Bitte überprüfe deine Eingabe";
      isValid = false;
    }
    if (!inputValue?.postleitzahl || inputValue?.postleitzahl?.trim() === "") {
      error.postleitzahl = "Bitte überprüfe deine Eingabe";
      isValid = false;
    }
    if (!inputValue?.ort || inputValue?.ort?.trim() === "") {
      error.ort = "Bitte überprüfe deine Eingabe";
      isValid = false;
    }
    // if (!inputValue?.kontakt || inputValue?.kontakt?.trim() === "") {
    //   error.kontakt = "Bitte überprüfe deine Eingabe";
    //   isValid = false;
    // }

    // if (!inputValue?.eMail || inputValue?.eMail?.trim() === "") {
    //   error.eMail = "Bitte überprüfe deine Eingabe";
    //   isValid = false;
    // } else
    if (inputValue.eMail) {
      if (!EMAIL_REGEX.test(inputValue.eMail)) {
        isValid = false;
        error.eMail = "Bitte überprüfe deine Eingabe";
      }
    }

    // if (!inputValue?.importantInfo || inputValue?.importantInfo?.trim() === "") {
    //   error.importantInfo = "Bitte überprüfe deine Eingabe";
    //   isValid = false;
    // }

    setError(error);

    return isValid;
  };

  const handleAddUser = () => {
    if (ValidateForm()) {
      setAddUpdateLoader(true);

      let body = {
        ...(inputValue?.vorname && { name: inputValue?.vorname }),
        ...(inputValue?.nachname && { nachname: inputValue?.nachname ? inputValue?.nachname : "", }),
        ...(inputValue?.firma && { firma: inputValue?.firma ? inputValue?.firma : "", }),
        ...(inputValue?.adresse && {strabe: inputValue?.adresse ? inputValue?.adresse : "", }),
        ...(inputValue?.postleitzahl && { pLZ: inputValue?.postleitzahl ? inputValue?.postleitzahl : "", }),
        ...(inputValue?.ort && { location: inputValue?.ort ? inputValue?.ort : "", }),
        ...(inputValue?.kontakt && { telephon: inputValue?.kontakt ? inputValue?.kontakt : "", }),
        ...(inputValue?.eMail && { email: inputValue?.eMail ? inputValue?.eMail : "", }),
        ...(inputValue?.importantInfo && { notizen: inputValue?.importantInfo ? inputValue?.importantInfo : "", }),
        ...(inputValue?.anrede && { contractions: inputValue?.anrede ? inputValue?.anrede : "", }),
        ...(inputValue?.website && { website: inputValue?.website ? inputValue?.website : "", }),
        ...(inputValue?.numberOfEmployees && { numberOfEmployees: inputValue?.numberOfEmployees? inputValue?.numberOfEmployees : "", }),
        ...(inputValue?.decisionMakerReached && { decisionMakerReached: inputValue?.decisionMakerReached? inputValue?.decisionMakerReached : "", }),
        ...(usersData?.name && {  benutzername: usersData?.name, }),
        ...(usersData?._id && { benutzerId: usersData?._id }),

        // name: inputValue?.vorname ? inputValue?.vorname : "",
        // nachname: inputValue?.nachname ? inputValue?.nachname : "",
        // firma: inputValue?.firma ? inputValue?.firma : "",
        // strabe: inputValue?.adresse ? inputValue?.adresse : "",
        // pLZ: inputValue?.postleitzahl ? inputValue?.postleitzahl : "",
        // location: inputValue?.ort ? inputValue?.ort : "",
        // telephon: inputValue?.kontakt ? inputValue?.kontakt : "",
        // email: inputValue?.eMail ? inputValue?.eMail : "",
        // notizen: inputValue?.importantInfo ? inputValue?.importantInfo : "",
        // contractions: inputValue?.anrede ? inputValue?.anrede : "",
        // benutzername: usersData?.name,
        // benutzerId: usersData?._id,
        // status: "offen",
      };

      ApiPost(`vattenfall/createLead`, body)
        .then((res) => {
          toast.success("Lead erfolgreich hinzugefügt");
          handleAddNewsClose();
          // handleChangeCommom("", "", filterData);
          setAddUpdateLoader(false);
          setInputValue({});
        })
        .catch((err) => {
          toast.error(err?.response?.data?.message);
          setAddUpdateLoader(false);
          handleAddNewsClose();
          setInputValue({});
        });
    }
  };
  const handleUpdateLead = () => {
    // if (ValidateForm()) {
    //   setAddUpdateLoader(true);
    //   let body = {
    //     name: inputValue?.vorname ? inputValue?.vorname : "",
    //     nachname: inputValue?.nachname ? inputValue?.nachname : "",
    //     firma: inputValue?.firma ? inputValue?.firma : "",
    //     strabe: inputValue?.adresse ? inputValue?.adresse : "",
    //     pLZ: inputValue?.postleitzahl ? inputValue?.postleitzahl : "",
    //     location: inputValue?.ort ? inputValue?.ort : "",
    //     telephon: inputValue?.kontakt ? inputValue?.kontakt : "",
    //     email: inputValue?.eMail ? inputValue?.eMail : "",
    //     notizen: inputValue?.importantInfo ? inputValue?.importantInfo : "",
    //     contractions: inputValue?.anrede ? inputValue?.anrede : "",
    //     benutzername: usersData?.name,
    //     benutzerId: usersData?._id,
    //     // status: "offen",
    //   };
    //   ApiPut(`vattenfall/updateLeadVatten?id=${inputValue?.id}`, body)
    //     .then((res) => {
    //       toast.success("Lead erfolgreich hinzugefügt");
    //       handleAddNewsClose();
    //       // handleChangeCommom("", "", filterData);
    //       setAddUpdateLoader(false);
    //       setIsEditLead(false);
    //       setInputValue({});
    //     })
    //     .catch((err) => {
    //       toast.error(err?.response?.data?.message);
    //       setAddUpdateLoader(false);
    //       setIsEditLead(false);
    //       handleAddNewsClose();
    //       setInputValue({});
    //     });
    // }
  };

  useEffect(() => {
    getStatusWiseData();
  }, [id, debouncValue]);
  const getTicketsPerStatus = useCallback(
    (newStatus) => {
      const data = tickets.filter((ticket) => ticket._id?.toLowerCase() === newStatus?.toLowerCase());
      return data?.[0]?.data;
    },
    [tickets, id]
  );

  const totalLengthTicket = tickets && tickets.reduce((sum, item) => sum + item?.data?.length, 0);

  const updateStatus = async (source, destination) => {
    try {
      let body = {
        status: destination?.droppableId,
      };
      let resp = await ApiPut(`vattenfall/updateLeadVatten?id=${source?.index}`, body);
      toast.success("status updated");
      getStatusWiseData();
    } catch (error) {
      toast.error(error?.message);
    }
  };

  const TicketItem = React.memo(({ item, index, cityName }) => (
    <Draggable draggableId={item?.leadId._id} index={item?.leadId._id} key={index}>
      {(provided) => (
        <div className="projeckt-ticket-main-body-box" ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps}>
          <div className="projeckt-ticket-main-body-box-header">
            <div className="projeckt-ticket-main-body-box-header-left-eye">
              <div className="projeckt-ticket-main-body-box-header-left-eye-circle">
                <svg focusable="false" aria-label="Open issue" className="Octicon-sc-9kayk9-0 cRyBKI" role="img" viewBox="0 0 16 16" width="16" height="16" fill="currentColor">
                  <path d="M8 9.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z"></path>
                  <path d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0ZM1.5 8a6.5 6.5 0 1 0 13 0 6.5 6.5 0 0 0-13 0Z"></path>
                </svg>
              </div>
              <span>benutzername: {item?.leadId?.benutzername}</span>
            </div>
          </div>

          <div className="projeckt-ticket-main-body-box-links"> </div>
          <div style={{ color: "#000" }}>Kunde: {item?.leadId?.name ? item?.leadId?.name : "-" + " " + item?.leadId?.nachname ? item?.leadId?.nachname : "-"}</div>
          <div className="projeckt-ticket-main-body-box-links-button">
            <a href="/">
              <button type="button">{item?.leadId?.status.toLocaleUpperCase()}</button>
            </a>
          </div>

          {/* {item?.leadId?.website && (
            <div className="projeckt-ticket-main-body-box-links-buttons" style={{ paddingTop: "5px" }}>
              <button type="button" style={{ backgroundColor: "#f86161", border: "none", padding: "0 10px", color: "#fff", borderRadius: "10px" }} onClick={() => window.open(item?.leadId?.website, '_blank')}>
                {item?.leadId?.website}
              </button>
            </div>
          )} */}

          {item?.leadId?.reason && item?.leadId?.status.toLocaleUpperCase() == "STORNO" && (
            <div className="projeckt-ticket-main-body-box-links-buttons" style={{ paddingTop: "5px" }}>
              <button type="button" style={{ backgroundColor: "#f86161", border: "none", padding: "0 10px", color: "#fff", borderRadius: "10px" }}>
                {item?.leadId?.reason?.toLocaleUpperCase()}
              </button>
            </div>
          )}

          {console.log("🚀 ~ Projekte ~ item:", item)}
          <div className="projeckt-ticket-main-body-box-links-ticket-button">
            <a href="/">
              <button type="button">
                {item?.leadId?.strabe || "-"} {item?.leadId?.pLZ || "-"}, {cityName?.label ? cityName?.label : cityName?.[0]?.label ? cityName?.[0]?.label : cityName ?? ""}
                {/* {item?.leadId?.location || "-"} */}
              </button>
            </a>
            <a href="/">
              <button>Name der Firma: {item?.leadId?.firma}</button>
            </a>
            <a href="/">
              <button type="button">{moment(item?.leadId?.createdAt).format("MMM D, YYYY")}</button>
            </a>
          </div>
        </div>
      )}
    </Draggable>
  ));
  

  const onDragEnd = async (result) => {
    const { destination, source } = result;

    if(destination.droppableId === "ZEITLICHE VERZÖGERUNG") {
      setDestinatedStatus(destination.droppableId)
    }

    const newTickets = [...tickets];

    const columnArray = newTickets.find((item) => item?._id === source.droppableId)?.data;

    const draggedTicket = columnArray?.find((item) => item.leadId._id === source.index);

    if (!destination || destination.droppableId === source.droppableId) return;

    if (source.droppableId?.startsWith("Termin") && destination.droppableId == "offen") return;

    if (source.droppableId == "offen" && destination.droppableId != "STORNO" && destination.droppableId != "NICHT ERREICHT" && destination.droppableId != "ZEITLICHE VERZÖGERUNG" && destination.droppableId != "Termin") {
      setModal(!modal);
      setLeadData(draggedTicket?.leadId);
      return null;
    }

    if (destination.droppableId == "STORNO") {
      setStatusModal(true);
      setLeadId(source?.index);
      setUpdatedStatus(destination?.droppableId);
      return;
    }

    const addTicketToColumn = () => {
      const isColumnExist = newTickets?.find((item) => item?._id === destination.droppableId);

      const updatedTickets = newTickets?.map((item) => {
        if (isColumnExist && item._id === destination.droppableId) {
          return {
            ...item,
            data: [...item.data, draggedTicket],
          };
        }

        if (item._id === source.droppableId) {
          const updatedData = item.data.filter((ticket) => ticket._id !== draggedTicket._id);
          return {
            ...item,
            data: updatedData,
          };
        }

        return item;
      });

      if (!isColumnExist) {
        const newColumn = {
          _id: destination.droppableId,
          data: [draggedTicket],
        };
        updatedTickets.push(newColumn);
      }
      setTickets(updatedTickets);
    };
    addTicketToColumn();
    await updateStatus(source, destination);
  };

  const resonData = [
    { id: 1, reason: "kein zugehöriger Parkplatz" },
    { id: 2, reason: "⁠kein Interesse" },
    { id: 3, reason: "Konkurrenzgebunden (vertraglich)" },
    { id: 4, reason: "Nicht unterschriftsberechtigt" },
    { id: 5, reason: "⁠zu wenig Stellflächen" },
  ];

  const [cityName, setCityName] = useState();

  const handleGetPostalCode = async () => {
    await ApiPost(`vattenfall/getPostalcode`)
      // await ApiGet(`vattenfall/getPostalcode?page=${page}&limite=${limit}&search=${search}`)
      .then((response) => {
        const data = response?.data?.payload;
        const optionData = data?.map((item) => ({
          value: item._id,
          label: item.cityName,
        }));
        setCityName(optionData);
      })
      .catch((error) => {
        toast.error(error);
      });
  };

  useEffect(() => {
    handleGetPostalCode();
  }, []);

  const getCityName = (city) => {
    const updatedCity = cityName?.filter((ele) => {
      if (city?.leadId?.location === ele?.value) {
        return ele?.label;
      }
    });
    console.log("updatedCityyyyyyyyyyy", updatedCity, "cityyyyyyyyy", city);
    return updatedCity;
  };

  const validation = () => {
    let isValid = true;
    let errors = {};
    if (!reason || reason?.trim() === "") {
      errors["reason"] = "Bitte überprüfe deine Eingabe";
      isValid = false;
    }
    setError(errors);
    return isValid;
  };
  const updateReason = async () => {
    if (validation()) {
      setLoading(true);
      try {
        let body = {
          status: updatedStaus,
          reason: reason,
        };
        let resp = await ApiPut(`vattenfall/updateLeadVatten?id=${leadId}`, body);

        toast.success("status updated");
        getStatusWiseData();
        setReason("");
      } catch (error) {
        toast.error(error?.message);
      } finally {
        setStatusModal(false);
        setLoading(false);
      }
    }
  };

  const handleChangeReason = (e) => {
    setReason(e.target.value);
    setError("");
  };

  return (
    <>
      <div className="search-trello-input">
        <input type="text" name="search" onChange={(e) => setSearch(e.target.value)} placeholder="Suche" />
        <button
          className="add-lead-button-alignment"
          onClick={() => {
            setIsShowLeadModel(true);
            setIsEditLead(false);
          }}
        >
          Leads hinzufügen
        </button>
      </div>
      <DragDropContext onDragEnd={onDragEnd}>
        <div className="projekte-container">
          <div className="projekct-ticket-main-layout">
            <div className="projekct-ticket-main">
              {ALL_STATUS.map((status, id) => (
                <Droppable droppableId={status.status} key={id} index={id}>
                  {(provided) => (
                    <div className="projeckt-ticket-box" ref={provided.innerRef} {...provided.droppableProps}>
                      <div className="projeckt-ticket-head">
                        <div className="projeckt-card-header-left-eye-content">
                          <div className="projeckt-header-circle"></div>
                          <p>{status.status?.toLocaleUpperCase()}</p>
                          <div className="projeckt-header-numericks">
                            <span>
                              {getTicketsPerStatus(status.status)?.length || 0} / {totalLengthTicket}
                            </span>
                          </div>
                        </div>
                        <div className="projeckt-ticket-menu-icon">
                          <img src={Moreicon} alt="Moreicon" />
                        </div>
                      </div>
                      <div className="this-title-header"></div>
                      <div className="projeckt-ticket-main-body">
                        {getTicketsPerStatus(status.status)?.map((item, idx) => (
                          <NavLink to={`/vattenlead?id=${item?.leadId._id}`}>
                            <TicketItem item={item} index={idx} key={idx} cityName={getCityName(item)} />
                          </NavLink>
                        ))}
                      </div>
                    </div>
                  )}
                </Droppable>
              ))}
            </div>
          </div>
        </div>
      </DragDropContext>

      <Modal show={isShowLeadModel} onHide={handleAddNewsClose} className="d-flex justify-content-center align-items-center">
        <AddLeadDetails
          inputValue={inputValue}
          setInputValue={setInputValue}
          handleOnClose={handleAddNewsClose}
          formType={isEditLead ? "update" : "add"}
          handleChange={handleChange}
          handleAddNews={isEditLead ? handleUpdateLead : handleAddUser}
          loading={addUpdateLoader}
          errors={error}
          setError={setError}
        />
      </Modal>

      {modal && (
        <>
          <div className="model-design-meeting">
            <div className="model-design-content">
              <div className="close-icon" onClick={() => setModal(!modal)}>
                <svg xmlns="http://www.w3.org/2000/svg" width="30px" height="30px" viewBox="0 0 24 24" fill="none">
                  <path
                    d="M20.7457 3.32851C20.3552 2.93798 19.722 2.93798 19.3315 3.32851L12.0371 10.6229L4.74275 3.32851C4.35223 2.93798 3.71906 2.93798 3.32854 3.32851C2.93801 3.71903 2.93801 4.3522 3.32854 4.74272L10.6229 12.0371L3.32856 19.3314C2.93803 19.722 2.93803 20.3551 3.32856 20.7457C3.71908 21.1362 4.35225 21.1362 4.74277 20.7457L12.0371 13.4513L19.3315 20.7457C19.722 21.1362 20.3552 21.1362 20.7457 20.7457C21.1362 20.3551 21.1362 19.722 20.7457 19.3315L13.4513 12.0371L20.7457 4.74272C21.1362 4.3522 21.1362 3.71903 20.7457 3.32851Z"
                    fill="#000"
                  />
                </svg>
              </div>
              <CustomCalendar ownMessage={""} setModal={setModal} modal={modal} leadStatus={"offen"} leadData={leadData} meetingDate={null} appoinmentData={[]} type={"add"} destinatedStatus={destinatedStatus} />
            </div>
          </div>
        </>
      )}

      {statusModal && (
        <>
          <div className="dropdown-modal">
            <div className="dropdown-modal-md">
              <div className="header-align">
                <div className="headfer-design">
                  <p>Stornogründe </p>
                </div>
                <div
                  className="close-icon"
                  onClick={() => {
                    setStatusModal(false);
                    setReason("");
                    setError("");
                  }}
                >
                  <svg xmlns="http://www.w3.org/2000/svg" width="20px" height="20px" viewBox="0 0 24 24" fill="none">
                    <path
                      d="M20.7457 3.32851C20.3552 2.93798 19.722 2.93798 19.3315 3.32851L12.0371 10.6229L4.74275 3.32851C4.35223 2.93798 3.71906 2.93798 3.32854 3.32851C2.93801 3.71903 2.93801 4.3522 3.32854 4.74272L10.6229 12.0371L3.32856 19.3314C2.93803 19.722 2.93803 20.3551 3.32856 20.7457C3.71908 21.1362 4.35225 21.1362 4.74277 20.7457L12.0371 13.4513L19.3315 20.7457C19.722 21.1362 20.3552 21.1362 20.7457 20.7457C21.1362 20.3551 21.1362 19.722 20.7457 19.3315L13.4513 12.0371L20.7457 4.74272C21.1362 4.3522 21.1362 3.71903 20.7457 3.32851Z"
                      fill="#000"
                    />
                  </svg>
                </div>
              </div>
              <div className="body-part-data">
                <label>
                  Stornogründe <span style={{ color: "red" }}>*</span>
                </label>
                <select name="reason" onChange={(e) => handleChangeReason(e)}>
                  <option value={""}>Stornogründe auswählen</option>
                  {resonData?.map((item) => {
                    return <option value={item?.reason}>{item?.reason}</option>;
                  })}
                </select>
                <span className="errorclass">{error?.reason}</span>
              </div>
              <div className="modl-dfot-design">
                <button onClick={updateReason}>{laoding ? <TailSpin color="#FFF" height={15} width={15} /> : "einreichen"}</button>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
}
